import _ from 'lodash'

export const keys = {
  tableConfigs: {
    add: 'TABLE_CONFIG_ADD'
  },
  tables: {
    add: 'TABLES_ADD',
    addRange: 'TABLES_ADDRANGE',
    remove: 'TABLES_REMOVE',
    clear: 'TABLES_CLEAR'
  },
  objects: {
    add: 'OBJECTS_ADD',
    remove: 'OBJECTS_REMOVE',
    clear: 'OBJECTS_CLEAR'
  }
}
export const state = {
  tableConfigs: [],
  tables: [],
  objects: []
}
export const mutations = {
  [keys.tableConfigs.add](state, table) {
    let foundTable = _.head(state.tables.filter(x => x.stateUID === table.stateUID))
    if (!foundTable) {
      foundTable = _.extend({
        stateUID: null,
        row_IDKey: 'id',
        items: []
      }, table)

      state.tables.push(foundTable)
    } else {
      foundTable = _.extend(foundTable, table)
    }
  },

  [keys.tables.add](state, { stateUID, item }) {
    const table = _.head(state.tables.filter(x => x.stateUID === stateUID))
    if (table) {
      for (let i = 0; i < table.items.length; i++) {
        if (_.get(table.items[i], table.row_IDKey) === _.get(item, table.row_IDKey)) {
          // already added
          return
        }
      }

      table.items.push(item)
    } else {
      console.warn(`ERROR: TABLE NOT FOUND. Unable to add item to table '${stateUID}'.`, item)
    }
  },
  [keys.tables.addRange](state, { stateUID, items }) {
    const table = _.head(state.tables.filter(x => x.stateUID === stateUID))
    if (table) {
      const idKey = table.row_IDKey
      const addedItems = table.items.filter(current => items.findIndex(item => current[idKey] === item[idKey]) > -1)
      const newItems = items.filter(y => addedItems.findIndex(x => x[idKey] === y[idKey]) === -1)

      table.items.push(...newItems)
    } else {
      console.warn(`ERROR: TABLE NOT FOUND. Unable to add items to table '${stateUID}'.`)
    }
  },
  [keys.tables.remove](state, { stateUID, item }) {
    const table = _.head(state.tables.filter(x => x.stateUID === stateUID))
    if (table) {
      const index = table.items.indexOf(item)
      if (index > -1) {
        table.items.splice(index, 1)
      } else {
        console.warn(`ERROR: TABLE NOT FOUND. Unable to delete item from table '${stateUID}'.`, item)
      }
    }
  },
  [keys.tables.clear](state, stateUID) {
    const table = _.head(state.tables.filter(x => x.stateUID === stateUID))
    if (table) {
      table.items = []
    } else {
      console.warn(`ERROR: TABLE NOT FOUND. Unable to clear the table '${stateUID}'.`)
    }
  },

  [keys.objects.add](state, { key, value }) {
    const found = state.objects.filter(x => x.key === key)
    for (let i = 0; i < found.length; i++) {
      state.objects.splice(i, 1)
    }

    state.objects.push({ key, value })
  },
  [keys.objects.remove](state, key) {
    const found = state.objects.filter(x => x.key === key)
    for (let i = 0; i < found.length; i++) {
      state.objects.splice(i, 1)
    }
  },
  [keys.objects.clear](state) {
    state.objects = []
  }
}
export const actions = {
  configTable({ commit }, table) {
    commit(keys.tableConfigs.add, table)
  },

  addTableItem({ commit }, { stateUID, items }) {
    commit(keys.tables.add, { stateUID, items })
  },
  addTableItemRange({ commit }, { stateUID, items }) {
    commit(keys.tables.addRange, { stateUID, items: items })
  },
  removeItemFromTable({ commit }, { stateUID, item }) {
    commit(keys.tables.remove, { stateUID, item })
  },
  clearItemsInTable({ commit }, stateUID) {
    commit(keys.tables.clear, stateUID)
  },

  addObject({ commit }, { key, value }) {
    commit(keys.objects.add, { key, value })
  },
  removeObject({ commit }, key) {
    commit(keys.objects.remove, key)
  },
  clearObjects({ commit }) {
    commit(keys.objects.clear)
  }
}
export const getters = {
  getItemsInTable: state => stateUID => (_.head(state.tables.filter(x => x.stateUID === stateUID)) || {}).items,
  getObject: state => key => _.head(state.objects.filter(x => x.key === key)),
  clipboard: state => {
    const tableConfigs = state.tableConfigs.map(item => ({ type: 'tableConfig', item }))
    const tables = state.tables.map(item => ({ type: 'table', item }))
    const objects = state.objects.map(item => ({ type: 'object', item }))

    return [...tableConfigs, ...tables, ...objects]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
